module.exports = __webpack_public_path__ + "img/simple-sampler.1ff47999.png";